import { ADD_REPORT, FETCH_REPORT, GET_REPORT } from '@/store/actions/shipping'
import { SET_PROGRESS_BAR, SET_STATUS_DOWNLOAD } from '@/store/actions/reports'
import { loadDayData, reportData } from '@/datas/SaveNomenclature'
import { mapGetters } from 'vuex'
import ProgressBar from '@/components/ProgressBar/ProgressBar'

export default {
  components: {
    ProgressBar,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    linkDownload: {
      type: String,
      default: '',
    },
    page: {
      type: String,
      default: 'report',
    },
  },
  data() {
    return {
      checkedScoupe: [],
      isBlackWhite: false,
      checkedWatermarks: {
        acts: '',
        ttns: '',
        tns: '',
      },
      checkedCombine: {
        acts: '',
        ttns: '',
        tns: '',
        payments: '',
        notes: '',
        dogovors: '',
        auto: '',
      },
      formData: {
        cargo: '',
        number: '',
        route: '',
        scopes: {},
        watermarks: {},
        combine: {},
      },
      progressBar: {
        is: false,
        start: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      report: 'reports/getCurrentReport',
    }),
    statusDownload: {
      get() {
        return this.$store.getters[`reports/getStatusDownload`]
      },
      set(value) {
        this.$store.dispatch(`reports/${SET_STATUS_DOWNLOAD}`, value)
      },
    },
  },
  watch: {
    statusDownload() {
      if (this.statusDownload === 'ready') {
        this.progressBar.is = false
        this.$store.dispatch(`reports/${SET_PROGRESS_BAR}`, 0)
      } else if (this.statusDownload === 'error') {
        this.progressBar.is = false
      }
    },
  },
  methods: {
    onSaveNomenclatureHandler() {
      this.statusDownload = ''
      const watermarks = this.getWatermark(
        this.checkedScoupe,
        this.checkedWatermarks,
      )
      const combine = this.getCombine(this.checkedScoupe, this.checkedCombine)
      const payload = {
        id: this.curBid,
        item: {
          cargo: this.formData.cargo,
          number: this.formData.number,
          route: this.formData.route,
        },
        scoupe: this.checkedScoupe,
        watermark: watermarks,
        combine,
        black_white: this.isBlackWhite ? ['acts', 'dogovors'] : [],
      }

      this.$store.dispatch(`shipping/${ADD_REPORT}`, payload).then(() => {
        this.$emit('save', payload)
        this.progressBar.is = true
        this.progressBar.start = true
      })
    },
    getWatermark(checkedScoupe, checkedWatermarks) {
      const options = ['ttns', 'tns', 'acts']

      return (
        checkedWatermarks &&
        options.filter(
          option => checkedScoupe.includes(option) && checkedWatermarks[option],
        )
      )
    },
    getCombine(checkedScoupe, checkedCombine) {
      const options = [
        'ttns',
        'tns',
        'acts',
        'payments',
        'notes',
        'dogovors',
        'auto',
      ]

      return (
        checkedCombine &&
        options.filter(
          option => checkedScoupe.includes(option) && checkedCombine[option],
        )
      )
    },
    openModal() {
      this.$store.dispatch(`shipping/${FETCH_REPORT}`, {
        cargo: this.report.cargo,
        number: this.report.number,
        route: this.report.route,
      })
      const { cargo, number, route } =
        this.$store.getters[`shipping/${GET_REPORT}`]

      this.formData = {
        ...this.formData,
        cargo,
        number,
        route,
      }
    },
    closeModal() {
      this.progressBar.is = false
      this.progressBar.start = false
      this.formData.item = ''
      this.$emit('close')
    },
    reloadDownloadReport() {
      this.onSaveNomenclatureHandler()
    },
    init() {
      if (this.page === 'loadDay') {
        this.formData.scopes = Object.assign(
          {},
          this.formData.scopes,
          loadDayData.scoupe,
        )
        this.formData.watermarks = Object.assign(
          {},
          this.formData.watermarks,
          loadDayData.watermarks,
        )
        this.formData.combine = Object.assign(
          {},
          this.formData.combine,
          loadDayData.combine,
        )
        this.checkedScoupe = loadDayData.checkedScoupe
      } else if (this.page === 'report') {
        this.formData.scopes = Object.assign(
          {},
          this.formData.scopes,
          reportData.scoupe,
        )
        this.formData.watermarks = Object.assign(
          {},
          this.formData.watermarks,
          reportData.watermarks,
        )
        this.formData.combine = Object.assign(
          {},
          this.formData.combine,
          reportData.combine,
        )
        this.checkedScoupe = reportData.checkedScoupe
      }
    },
  },
  mounted() {
    this.init()
  },
}
